import { Component, OnInit, Input } from '@angular/core';
import { Conversion } from 'src/app/models/conversion.model';
import { NbDialogRef } from '@nebular/theme';
import { User } from 'src/app/models/users.model';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
const firestore = firebase.firestore;

@Component({
  selector: 'app-conversion-details',
  templateUrl: './conversion-details.component.html',
  styleUrls: ['./conversion-details.component.scss'],
})
export class ConversionDetailsComponent implements OnInit {
  @Input()
  conversion: Conversion;

  title: string;

  conversionUser: User;

  constructor(protected dialogRef: NbDialogRef<ConversionDetailsComponent>) {}

  async ngOnInit() {
    this.title = this.getTitle();
    this.conversionUser = (await firestore().doc(`users/${this.conversion.userUid}`).get()).data() as User;
  }

  getTitle(): string {
    if (this.conversion.deleted === true) {
      return 'Conversion Deleted';
    } else if (this.conversion.healthCheck?.healthy === true) {
      return 'Successfully Converted';
    } else {
      if (this.conversion.healthCheck?.errors?.some((a) => a.row === -1)) {
        return 'Failed to Parse';
      } else {
        return 'Inconsistencies Found';
      }
    }
  }

  viewRaw() {
    const data = JSON.stringify(this.conversion, null, 2);
    const x = window.open();
    x.document.open();
    x.document.write('<html><body><pre>' + data + '</pre></body></html>');
    x.document.close();
  }
}
